import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import hi from "./locales/hi/common.json";
import gu from "./locales/gu/common.json";

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
            gu: { translation: gu },
        },
        // default language fallback
        fallbackLng: "en",
        supportedLngs: ["en", "hi", "gu"],
        detection: {
            // detect from querystring, localStorage, navigator order
            order: ["querystring", "localStorage", "navigator"],
            caches: ["localStorage"],
        },
        interpolation: {
            escapeValue: false,
        },
        returnNull: false,
    });

export default i18n;


